import { EmailAccountValidator } from './accounts-validators/email-account-validator';
import { NumericAccountValidator } from './accounts-validators/numeric-account-validator';
import { ArgentinaBankAccountValidator } from '@app/core/account-service-provider/accounts-validators/argentina-bank-account-validator';
import { GenericAccountValidator } from './accounts-validators/generic-account-validator';
import { EuropeBankAccountValidator } from './accounts-validators/europe-bank-account-validator';
import { UalaAddressAccountValidator } from './accounts-validators/uala-address-account-validator';
import { BitcoinAddressAccountValidator } from './accounts-validators/bitcoin-address-account-validator';
import { EthereumAddressAccountValidator } from './accounts-validators/ethereum-address-account-validator';
import { PerfectMoneyAccountValidator } from './accounts-validators/perfect-money-account-validator';
import { Trc20Bep20AddressAccountValidator } from './accounts-validators/trc20-bep20-address-account-validator.ts';
import { CuentaDigitalAccountValidator } from './accounts-validators/cuentadigital-account-validator';
import { MexicoBankAccountValidator } from './accounts-validators/mexico-bank-account-validator';
import { PayeerAccountValidator } from './accounts-validators/payeer-account-validator';
import { ColombiaBankAccountValidator } from './accounts-validators/colombia-bank-account-validator';
import { Router } from '@angular/router';
import { ServiceLoader } from '../services/service-loader';
import { LenguagesHelper } from '../helpers/lenguages.helper';
import { NequiAccountValidator } from './accounts-validators/nequi-account-validator';
import { PixAccountValidator } from './accounts-validators/pix-account-validator';
interface IDataServiceProvider {
    [account_type: string]: GenericAccountValidator;
}
export class AccountServiceProvider {
    public data: IDataServiceProvider = {
        email: new EmailAccountValidator(),
        numeric: new NumericAccountValidator(),
        alpha_num: new GenericAccountValidator(),
        argentina_bank_account: new ArgentinaBankAccountValidator(),
        mexico_bank_account: new MexicoBankAccountValidator(),
        colombia_bank_account: new ColombiaBankAccountValidator(),
        europe_bank_account: new EuropeBankAccountValidator(),
        uala_address: new UalaAddressAccountValidator(),
        venezuela_bank_account: new GenericAccountValidator(),
        bitcoin_address: new BitcoinAddressAccountValidator(),
        ethereum_address: new EthereumAddressAccountValidator(),
        trc20_bep20_address: new Trc20Bep20AddressAccountValidator(),
        cuenta_digital_account: new CuentaDigitalAccountValidator(),
        payeer_account: new PayeerAccountValidator(),
        nequi_account: new NequiAccountValidator(),
        pix_account: new PixAccountValidator(),
        perfect_money_account: new PerfectMoneyAccountValidator()
    };
    private router: Router;
    private lenguagesHelper: LenguagesHelper = new LenguagesHelper();

    public constructor() {
        this.router = ServiceLoader.injector.get(Router);
    }
    public getValidatorAccount(accountType: string | null | undefined): GenericAccountValidator {
        const validator: GenericAccountValidator =
            accountType && this.data[accountType] ? this.data[accountType] : new GenericAccountValidator();
        const lang: string = this.lenguagesHelper.extractLenguageFromPath(this.router.url);

        return validator.setLang(lang);
    }
}
